import {
  GET_BULK_CONSIGNMENT, GET_BULK_CONSIGNMENT_COMPLETED, GET_BULK_CONSIGNMENT_FAILED,
  RECEIVE_BULK_PRODUCT, RECEIVE_BULK_PRODUCT_COMPLETED, RECEIVE_BULK_PRODUCT_FAILED,
  SEARCH_BULK_CONSIGNMENTS, SEARCH_BULK_CONSIGNMENTS_COMPLETED, SEARCH_BULK_CONSIGNMENTS_FAILED,
  UPDATE_RECEIVED_BULK_PRODUCT, UPDATE_RECEIVED_BULK_PRODUCT_COMPLETED, UPDATE_RECEIVED_BULK_PRODUCT_FAILED,
  RECORD_BULK_PRODUCT_WASTE, RECORD_BULK_PRODUCT_WASTE_COMPLETED, RECORD_BULK_PRODUCT_WASTE_FAILED,
  PACKAGE_PRODUCT, PACKAGE_PRODUCT_COMPLETED, PACKAGE_PRODUCT_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  bulkConsignments: [],
  bulkConsignmentsLoading: false,
  bulkConsignmentsError: null,
  bulkConsignment: null,
  bulkConsignmentLoading: false,
  bulkConsignmentError: null,
  receivingBulkProduct: false,
  updatingReceivedBulkProduct: false,
  search: searchDefault,
  recordingBulkProductWaste: false,
  packagingProduct: false,
};

const bulkConsignmentReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_BULK_CONSIGNMENTS: return handleSearch(state, 'search', action.payload);
    case SEARCH_BULK_CONSIGNMENTS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_BULK_CONSIGNMENTS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_BULK_CONSIGNMENT: {
      return {
        ...state,
        bulkConsignmentLoading: true,
        bulkConsignment: null,
        bulkConsignmentError: null,
      };
    }
    case GET_BULK_CONSIGNMENT_COMPLETED: {
      return {
        ...state,
        bulkConsignmentLoading: false,
        bulkConsignment: action.payload,
      };
    }
    case GET_BULK_CONSIGNMENT_FAILED: {
      return {
        ...state,
        bulkConsignmentLoading: false,
        bulkConsignmentError: action.payload,
      };
    }
    case RECEIVE_BULK_PRODUCT: {
      return {
        ...state,
        receivingBulkProduct: true,
      };
    }
    case RECEIVE_BULK_PRODUCT_COMPLETED: {
      return {
        ...state,
        receivingBulkProduct: false,
      };
    }
    case RECEIVE_BULK_PRODUCT_FAILED: {
      return {
        ...state,
        receivingBulkProduct: false,
      };
    }
    case UPDATE_RECEIVED_BULK_PRODUCT: {
      return {
        ...state,
        updatingReceivedBulkProduct: true,
      };
    }
    case UPDATE_RECEIVED_BULK_PRODUCT_COMPLETED: {
      return {
        ...state,
        updatingReceivedBulkProduct: false,
      };
    }
    case UPDATE_RECEIVED_BULK_PRODUCT_FAILED: {
      return {
        ...state,
        updatingReceivedBulkProduct: false,
      };
    }
    case RECORD_BULK_PRODUCT_WASTE: {
      return {
        ...state,
        recordingBulkProductWaste: true,
      };
    }
    case RECORD_BULK_PRODUCT_WASTE_COMPLETED: {
      return {
        ...state,
        recordingBulkProductWaste: false,
      };
    }
    case RECORD_BULK_PRODUCT_WASTE_FAILED: {
      return {
        ...state,
        recordingBulkProductWaste: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    case PACKAGE_PRODUCT: {
      return {
        ...state,
        packagingProduct: true,
      };
    }
    case PACKAGE_PRODUCT_COMPLETED: {
      return {
        ...state,
        packagingProduct: false,
      };
    }
    case PACKAGE_PRODUCT_FAILED: {
      return {
        ...state,
        packagingProduct: false,
      };
    }
    default:
      return state;
  }
};

export default bulkConsignmentReducer;



// WEBPACK FOOTER //
// ./src/BulkConsignment/reducer.js